import { AnalyticsBrowser } from "@segment/analytics-next";

export const analytics = AnalyticsBrowser.load({
  writeKey: 'MvsF3aS44HJTiFqwZBol1FYAYqAATVM4',
});